import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Text = styled.h1`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: ${props => (props.theme.isMobile ? '26px' : '32px')};
  margin: 0;
  line-height: 100%;
  color: ${props => props.theme.bodyColor};
  margin-top: ${props => (props.theme.isMobile ? 24 : 16)}px;
`;

export default function Name({ name }) {
  return <Text>{name}</Text>;
}

Name.propTypes = { name: PropTypes.string.isRequired };
